export const SettingsURLs = {
    settingsView: '/settings',
}